var _rect, _circle, _path, _path2, _circle2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 4.5,
    width: 10.5,
    height: 12.5,
    rx: 2,
    stroke: "currentColor",
    strokeWidth: 1.9
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 8.3,
    r: 2.15,
    stroke: "currentColor",
    strokeWidth: 1.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9 14.05C7.45 12.55 8.5 11.75 9.65 11.75C10.8 11.75 11.85 12.55 12.4 14.05",
    stroke: "currentColor",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.1L8.85 12.1L9.5 13.2L10.15 12.1L9.5 11.1Z",
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.25,
    cy: 16.5,
    r: 3.25,
    stroke: "currentColor",
    strokeWidth: 1.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 14.9V18.1",
    stroke: "currentColor",
    strokeWidth: 1.9,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.65 16.5H18.85",
    stroke: "currentColor",
    strokeWidth: 1.9,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAdmin);
export default __webpack_public_path__ + "static/media/addAdmin.ac5c3a9f65f18625a85d94ec9abb2561.svg";
export { ForwardRef as ReactComponent };